import "./Footer.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInstagram,
} from "react-icons/fa";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">

        {/* BRAND */}
        <div className="footer__brand footer__col">
          <div className="footer__logo">
            <img src={logo} alt="Luxego Autospa Logo" />
          </div>
          <h3>Luxego</h3>
          <span className="footer__tagline">Autospa on Wheels</span>
          <p>
            Premium mobile car detailing services delivered to your doorstep
            in Chelmsford and Essex.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer__links footer__col">
          <h4>Quick Links</h4>
          <a href="/">Home</a>
          <a href="/services">Services</a>
          <a href="/contact">Contact</a>
        </div>

        {/* CONTACT */}
<div className="footer__contact footer__col">
  <h4>Contact Us</h4>

  <a href="tel:07721482404" className="footer__contact-item">
    <FaPhoneAlt />
    <span>07721 482404</span>
  </a>

  <a
    href="mailto:info@luxegoautospa.com"
    className="footer__contact-item"
  >
    <FaEnvelope />
    <span>info@luxegoautospa.com</span>
  </a>

  <a
    href="https://instagram.com/luxego_autospa"
    target="_blank"
    rel="noopener noreferrer"
    className="footer__contact-item"
  >
    <FaInstagram />
    <span>@luxego_autospa</span>
  </a>
</div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer__bottom">
        <span>© 2026 Luxego Autospa. All rights reserved.</span>
        <span>Mobile Car Detailing · Chelmsford, Essex, UK</span>
      </div>
    </footer>
  );
}
